import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthContext } from '@/modules/auth/ui/AuthProvider';
import { queryKeys } from './queryKeys';

export function useUpdatePreferences() {
  const { authFetch } = useAuthContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (preferences) => {
      const response = await authFetch('/api/users/update-preferences', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(preferences),
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to update preferences');
      }
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.user.settings });
    },
  });
}

export function useOpenCustomerPortal() {
  const { authFetch } = useAuthContext();

  return useMutation({
    mutationFn: async (returnUrl) => {
      const response = await authFetch(`/api/users/customer-portal?returnUrl=${encodeURIComponent(returnUrl)}`);
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to create customer portal session');
      }
      return response.json();
    },
  });
}
